
<template>
  <div class="overview-area ptb-100 bg-f9f9f9">
    <div class="container">
      <div class="overview-box">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12 overview-image">
            <img src="../../assets/images/overview/overview1.png" data-aos="fade-up" alt="Por que escolher a Fontes Business">
          </div>
          <div class="col-lg-6 col-md-12 overview-content">
            <span class="sub-title">Por Que Nos Escolher?</span>
            <h2>Estamos aqui para impulsionar o seu negócio</h2>
            <ul class="overview-list">
              <li data-aos="fade-up" data-aos-duration="1200">
                <span>
                    <i class="flaticon-draw-check-mark"></i>
                    Desenvolvimento Personalizado
                </span>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                <span>
                    <i class="flaticon-draw-check-mark"></i>
                    Soluções em Nuvem
                </span>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                <span>
                    <i class="flaticon-draw-check-mark"></i>
                    Arquitetura Escalável
                </span>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="300">
                <span>
                    <i class="flaticon-draw-check-mark"></i>
                    Integração de Sistemas
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="overview-box">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12 overview-content">
            <span class="sub-title">Nosso Objetivo</span>
            <h2>Melhor desenvolvimento de software da sua região</h2>
            <ul class="overview-list">
              <li data-aos="fade-up" data-aos-duration="1200">
                <span>
                    <i class="flaticon-draw-check-mark"></i>
                    Sistemas Web Modernos
                </span>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                <span>
                    <i class="flaticon-draw-check-mark"></i>
                    Aplicativos Mobile Nativos
                </span>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                <span>
                    <i class="flaticon-draw-check-mark"></i>
                    Automação de Processos
                </span>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="300">
                <span>
                    <i class="flaticon-draw-check-mark"></i>
                    E-commerce Completo
                </span>
              </li>
            </ul>
          </div>
          <div class="col-lg-6 col-md-12 overview-image">
            <img src="../../assets/images/overview/overview2.png" data-aos="fade-up" alt="Serviços de desenvolvimento Fontes Business">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhyChooseUs'
}
</script>